import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { DefaultCarrierByCountryServiceEntryFragmentFragmentDoc } from '../fragments/defaultCarrierByCountryServiceEntry.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SetDefaultCarrierByCountryConfigMutationVariables = Types.Exact<{
  entries: Array<Types.DefaultCarrierByCountryInput> | Types.DefaultCarrierByCountryInput;
}>;


export type SetDefaultCarrierByCountryConfigMutation = { __typename?: 'Mutation', setDefaultCarrierByCountryConfig: Array<{ __typename?: 'DefaultCarrierByCountryEntry', country_code: string, defaults: Array<{ __typename?: 'DefaultCarrierByCountryServiceEntry', carrier_service: Types.OpsOrderCarrierService, carrier: Types.OpsOrderCarrier }> }> };


export const SetDefaultCarrierByCountryConfigDocument = gql`
    mutation SetDefaultCarrierByCountryConfig($entries: [DefaultCarrierByCountryInput!]!) {
  setDefaultCarrierByCountryConfig(entries: $entries) {
    country_code
    defaults {
      ...DefaultCarrierByCountryServiceEntryFragment
    }
  }
}
    ${DefaultCarrierByCountryServiceEntryFragmentFragmentDoc}`;
export type SetDefaultCarrierByCountryConfigMutationFn = Apollo.MutationFunction<SetDefaultCarrierByCountryConfigMutation, SetDefaultCarrierByCountryConfigMutationVariables>;

/**
 * __useSetDefaultCarrierByCountryConfigMutation__
 *
 * To run a mutation, you first call `useSetDefaultCarrierByCountryConfigMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultCarrierByCountryConfigMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultCarrierByCountryConfigMutation, { data, loading, error }] = useSetDefaultCarrierByCountryConfigMutation({
 *   variables: {
 *      entries: // value for 'entries'
 *   },
 * });
 */
export function useSetDefaultCarrierByCountryConfigMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultCarrierByCountryConfigMutation, SetDefaultCarrierByCountryConfigMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultCarrierByCountryConfigMutation, SetDefaultCarrierByCountryConfigMutationVariables>(SetDefaultCarrierByCountryConfigDocument, options);
      }
export type SetDefaultCarrierByCountryConfigMutationHookResult = ReturnType<typeof useSetDefaultCarrierByCountryConfigMutation>;
export type SetDefaultCarrierByCountryConfigMutationResult = Apollo.MutationResult<SetDefaultCarrierByCountryConfigMutation>;
export type SetDefaultCarrierByCountryConfigMutationOptions = Apollo.BaseMutationOptions<SetDefaultCarrierByCountryConfigMutation, SetDefaultCarrierByCountryConfigMutationVariables>;